import { formatAsMonthAndYear } from "../../../../../core/helpers/date-formatting-util.js";
import { newDate } from "../../../../../core/helpers/date-util.js";
import nullPeriod from "../../../../period/nullPeriod.js";
import ReportColumn from "./ReportColumn.js";

/**
 * `openingBalanceSheetBalanceColumn` is a specific column corresponding to the server-side OpeningBalanceSheetBalanceColumn.
 *
 * @param {period} [spec.period] - Period reflected in the column
 */
export default class OpeningBalanceSheetBalanceColumn extends ReportColumn {
	constructor({ period }) {
		super(...arguments);

		this._period = period || nullPeriod;
	}

	_getFormattedDate() {
		return formatAsMonthAndYear(this._getDate());
	}

	_getDate() {
		return newDate(this._period.end);
	}

	static getType() {
		return "OpeningBalanceSheetBalanceColumn";
	}
}
